<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g stroke="currentColor" style="stroke-width:1.4px;fill:none" transform="translate(5 1)"><rect width="10" height="10" stroke="none" rx="1" style="stroke:none"/><rect width="8.6" height="8.6" x=".7" y=".7" rx=".3" style="fill:none"/></g><g clip-path="polygon(50% 0, 50% 50%, 100% 50%, 100% 100%, 0% 100%, 0 0)"><g stroke="currentColor" style="stroke-width:1.4px;fill:none" transform="translate(.999 1) translate(0 4)"><rect width="10" height="10" stroke="none" rx="1" style="stroke:none"/><rect width="8.6" height="8.6" x=".7" y=".7" rx=".3" style="fill:none"/></g></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-multitap',
});
</script>
